import { Directive } from '@angular/core';
import { TableCellData } from '../contract/table-cell-data.contract';
import { TableRowData } from '../contract/table-data.contract';
import { TableColumn } from '../contract/table-column.contract';

@Directive()
export class TableCellBase<TValue = unknown> {
  row: TableRowData;
  column: TableColumn;
  value: TValue | undefined;

  constructor(cellData: TableCellData<unknown>) {
    this.row = cellData.row;
    this.column = cellData.column;
    if (this.column?.field) {
      this.value = <TValue>cellData.row?.[this.column.field];
    }
  }
}
